export default __webpack_public_path__ + "assets/mug.e27f9311.glb";